// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"597ts":[function(require,module,exports,__globalThis) {
// auth.js
var _auth = require("firebase/auth");
var _configJs = require("./config.js");
var _translatorJs = require("../custom/translator.js");
var _storage = require("firebase/storage");
var _commonJs = require("./common.js");
var _globalJs = require("./global.js");
var _database = require("firebase/database");
const authView = document.getElementById('auth-view');
const protectedView = document.getElementById('protected-view');
const authForm = document.getElementById('auth-form');
const emailInput = document.getElementById('email');
const passwordInput = document.getElementById('password');
const formTitle = document.getElementById('form-title');
const formSubtitle = document.getElementById('form-subtitle');
const submitBtn = document.getElementById('submit-btn');
const switchModeBtn = document.getElementById('switch-mode');
const toggleWrapper = document.getElementById('toggle-wrapper');
const toggleInfo = document.getElementById('toggle-info');
const errorMessage = document.getElementById('error-message');
const userDisplayEmail = document.getElementById('user-display-email');
const logoutBtn = document.getElementById('logout-btn');
const signupFields = document.getElementById('signup-only-fields');
const nameInput = document.getElementById('display-name');
const fileInput = document.getElementById('profile-pic');
const countryInput = document.getElementById('country');
const langInput = document.getElementById('language');
const previewContainer = document.getElementById('preview-container');
const imagePreview = document.getElementById('image-preview');
let lang;
let auth;
let isLoginMode = true;
let activeLs = [];
let isFinishRegistration = false;
let dbRef;
$('document').ready(function() {
    //initCampScroll();
    lang = (0, _globalJs.getLanguage)();
    initAuthLs();
    initLs();
});
function initAuthLs() {
    (0, _configJs.initFb)();
    dbRef = (0, _database.getDatabase)();
    auth = (0, _auth.getAuth)();
    auth.languageCode = lang;
    // 1. Session Observer Sync
    let unsubAuth = (0, _auth.onAuthStateChanged)(auth, (user)=>{
        if (user) verifyUserData(user);
        else {
            authView.classList.remove('hidden');
            protectedView.classList.add('hidden');
        }
    });
    activeLs.push(unsubAuth);
}
async function verifyUserData(user) {
    //check if user info is registered in the database
    const dbUser = (0, _database.ref)(dbRef, `user/${user.uid}`);
    const snapshot = await (0, _database.get)(dbUser);
    if (!snapshot.exists()) {
        //show registration form with email pre-filled and no password required and hidden
        emailInput.value = user.email;
        passwordInput.classList.add('hidden');
        passwordInput.removeAttribute('required');
        isFinishRegistration = true;
        isLoginMode = false;
        switchModeBtn.click();
    } else {
        isFinishRegistration = false;
        //check if redirect exists in the URL and handle it accordingly
        authForm.reset();
        const urlParams = new URLSearchParams(window.location.search);
        const redirect = urlParams.get('redirect') || sessionStorage.getItem('auth_redirect_target') || '/portal.html';
        sessionStorage.removeItem('auth_redirect_target');
        window.location.href = redirect;
    //userDisplayEmail.textContent = user.email;
    //authView.classList.add('hidden');
    //protectedView.classList.remove('hidden');
    }
    hideError();
}
async function initLs() {
    console.log('auth lang selected:', lang);
    (0, _commonJs.loadCountries)(lang, countryInput);
    (0, _commonJs.loadLangsList)(lang, langInput);
    window.addEventListener('beforeunload', ()=>{
        activeLs.forEach((stopLs)=>{
            stopLs();
        });
    });
    const passwordToggleBtn = document.getElementById('password-toggle-btn');
    passwordToggleBtn.addEventListener('click', ()=>{
        // Read the current mask setting state
        const currentType = passwordInput.getAttribute('type');
        if (currentType === 'password') {
            // Unmask the text input view
            passwordInput.setAttribute('type', 'text');
            passwordToggleBtn.classList = 'fa-solid fa-eye-slash'; // Shifting face icon placeholder
            passwordToggleBtn.setAttribute('data-i18n-attr', '{"aria-label": "hide_password","title": "hide_password"}');
            (0, _translatorJs.i18n).translatePage(passwordToggleBtn);
            passwordToggleBtn.setAttribute('aria-label', 'Hide Password');
        } else {
            // Mask the text input view
            passwordInput.setAttribute('type', 'password');
            passwordToggleBtn.classList = 'fa-solid fa-eye'; // Standard eye icon placeholder
            passwordToggleBtn.setAttribute('data-i18n-attr', '{"aria-label": "show_password","title": "show_password"}');
            (0, _translatorJs.i18n).translatePage(passwordToggleBtn);
            passwordToggleBtn.setAttribute('aria-label', 'Show Password');
        }
        // Retain input cursor engagement after clicking the icon tag
        passwordInput.focus();
    });
    // 1. Listen for file selection changes
    fileInput.addEventListener('change', function() {
        const file = this.files[0];
        if (file) {
            const reader = new FileReader();
            // When the file is completely read, update the image element source
            reader.addEventListener('load', function() {
                imagePreview.setAttribute('src', this.result);
                previewContainer.classList.remove('hidden');
            });
            // Convert the image file into a temporary data URL string
            reader.readAsDataURL(file);
        } else // Clear preview if user cancels selection
        clearPreview();
    });
    // 2. Interface Mode Translation Handler
    // 3. Update your existing switchModeBtn event listener
    switchModeBtn.addEventListener('click', ()=>{
        isLoginMode = !isLoginMode;
        hideError();
        clearPreview(); // <-- Clear the preview when toggling between Login and Sign Up
        //authForm.reset(); // Clear form fields
        emailInput.value = '';
        passwordInput.value = '';
        if (isLoginMode) {
            if (isFinishRegistration) {
                //sign out
                isFinishRegistration = false;
                logoutBtn.click();
            }
            formTitle.setAttribute('data-i18n', 'access_account');
            submitBtn.setAttribute('data-i18n', 'sign_in');
            (0, _translatorJs.i18n).translatePage(formTitle);
            (0, _translatorJs.i18n).translatePage(submitBtn);
            signupFields.classList.add('hidden');
            nameInput.removeAttribute('required');
            fileInput.removeAttribute('required');
            countryInput.removeAttribute('required');
            langInput.removeAttribute('required');
            toggleInfo.setAttribute('data-i18n', 'no_account');
            switchModeBtn.setAttribute('data-i18n', 'sign_up');
            toggleInfo.textContent = (0, _translatorJs.i18n).t('no_account');
            switchModeBtn.textContent = (0, _translatorJs.i18n).t('sign_up');
            // 🎯 Focus the email field on the Login screen
            emailInput.focus();
        } else {
            formTitle.setAttribute('data-i18n', isFinishRegistration ? 'finish_registration' : 'create_account');
            submitBtn.setAttribute('data-i18n', isFinishRegistration ? 'finish_registration' : 'sign_up');
            (0, _translatorJs.i18n).translatePage(formTitle);
            (0, _translatorJs.i18n).translatePage(submitBtn);
            signupFields.classList.remove('hidden');
            nameInput.setAttribute('required', '');
            fileInput.setAttribute('required', '');
            countryInput.setAttribute('required', '');
            langInput.setAttribute('required', '');
            toggleInfo.setAttribute('data-i18n', isFinishRegistration ? 'change_account' : 'already_account');
            switchModeBtn.setAttribute('data-i18n', isFinishRegistration ? 'logout' : 'login');
            toggleInfo.textContent = (0, _translatorJs.i18n).t(isFinishRegistration ? 'change_account' : 'already_account');
            switchModeBtn.textContent = (0, _translatorJs.i18n).t(isFinishRegistration ? 'logout' : 'login');
            // 🎯 Focus the name field on the Registration screen
            nameInput.focus();
        }
    // document
    //   .getElementById('switch-mode')
    //   .addEventListener('click', () => switchModeBtn.click());
    });
    // 3. Execution Processing Request Lifecycle
    authForm.addEventListener('submit', async (e)=>{
        e.preventDefault();
        hideError();
        const email = emailInput.value.trim();
        const password = passwordInput.value;
        try {
            if (isLoginMode) await (0, _auth.signInWithEmailAndPassword)(auth, email, password);
            else {
                // A. Create native authentication profile
                let user;
                if (isFinishRegistration) {
                    user = auth.currentUser;
                    isFinishRegistration = false;
                } else {
                    const userCredential = await (0, _auth.createUserWithEmailAndPassword)(auth, email, password);
                    user = userCredential.user;
                }
                // B. Upload file attachment to Firebase Storage bucket
                const file = fileInput.files[0];
                const fileRef = storageRef(storage, `profile/${user.uid}`);
                const uploadSnapshot = await (0, _configJs.uploadBytes)(fileRef, file);
                const photoURL = await (0, _configJs.getDownloadURL)(uploadSnapshot.ref);
                // C. Sync name and photo attributes directly to Firebase Auth Profile
                await updateProfile(user, {
                    displayName: nameInput.value.trim(),
                    photoURL: photoURL
                });
                // D. Save profile record down into the Realtime Database JSON path
                const dbUser = (0, _database.ref)(dbRef, `user/${user.uid}`);
                await set(dbUser, {
                    name: nameInput.value.trim(),
                    date: new Date().getTime(),
                    country: countryInput.value,
                    lang: langInput.value,
                    imgUrl: photoURL,
                    id: user.uid
                });
            }
        } catch (error) {
            displayError((0, _translatorJs.i18n).t(error.code) || (0, _translatorJs.i18n).t('def_error'));
        }
    });
    // 4. Session Disconnect Link
    logoutBtn.addEventListener('click', async ()=>{
        try {
            await (0, _auth.signOut)(auth);
        } catch (error) {
            displayError((0, _translatorJs.i18n).t('logout_error'));
        }
    });
}
// 2. Clear preview helper function
function clearPreview() {
    imagePreview.setAttribute('src', '');
    previewContainer.classList.add('hidden');
}
function displayError(message) {
    errorMessage.textContent = message; //.replace('Firebase: ', '');
    errorMessage.style.display = 'block';
}
function hideError() {
    errorMessage.textContent = '';
    errorMessage.style.display = 'none';
}

},{"firebase/auth":"dZ6yw","./config.js":"324tf","../custom/translator.js":"eJcTf","firebase/storage":"9JHfQ","./common.js":"jYzpo","./global.js":"awxwA","firebase/database":"3h9CB"}]},["597ts"], "597ts", "parcelRequiredd39", {})

//# sourceMappingURL=auth.17c63d40.js.map
